import { render, staticRenderFns } from "./limitActivitiesDetails.vue?vue&type=template&id=0017f132&scoped=true&"
import script from "./limitActivitiesDetails.vue?vue&type=script&lang=js&"
export * from "./limitActivitiesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0017f132",
  null
  
)

export default component.exports